import { getAppSettings, getAppSettingsAsString, loadAppSettings, setClientCredentials } from "./appSettings";
import * as mqttClient from '../messaging/mqttClient';
import * as logger from '../logging/logger';
import * as api from '../api/makeRequest';
import { logUncaughtErrors } from "../errors/uncaughtErrorHandler";
import getAccessToken, { initAccessToken } from "./bearerToken";
import listenForUserInteractions from './listenForUserInteractions';

interface InitializeOptions {
    clientCredentials: string;
    brokerUrl: string;
    scope: string;
    logOnUnsuccessfulStatusCode?: boolean;
    brokerUsername:string
    brokerPassword:string
}

export async function initialize(options: InitializeOptions) {
    loadAppSettings();
    setClientCredentials(options.clientCredentials);

    const appSettings = getAppSettings();

    mqttClient.configure({
        sessionId: appSettings.sessionId,
        brokerUrl: options.brokerUrl,
        username:options.brokerUsername,
        password:options.brokerPassword
    });

    logger.configure({
        enableConsoleLogging: true,
        enableApiLogging: true,
        logLevel: getAppSettings().logLevel,
        clientId: appSettings.clientId,
        sessionId: appSettings.sessionId
    });

    logUncaughtErrors();

    await initAccessToken(appSettings.clientIdentity, appSettings.clientSecret, options.scope);

    api.configureMakeRequest({
        baseUrl: '/api/',
        sessionId: appSettings.sessionId,
        addHeadersOnEachRequest: async () => {
            const token = await getAccessToken(appSettings.clientIdentity, appSettings.clientSecret, options.scope);
            return {
                Authorization: `Bearer ${token}`
            };
        },
        log: (level, message) => {
            logger.log(level, message);
        },
        logOnUnsuccessfulStatusCode: !!options.logOnUnsuccessfulStatusCode
    });

    listenForUserInteractions();

    logger.log('Info', `Client: Started: ${window.location}`);
    logger.log('Info', `Client: Settings: ${getAppSettingsAsString()}`);

    mqttClient.init();
}
